
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("sRTqL", function(module, exports) {

$parcel$export(module.exports, "WatchDialogWatchContentMutation", () => $056c6bacd68f6aa5$export$f26331a5953372af);

var $d2LG0 = parcelRequire("d2LG0");
const $056c6bacd68f6aa5$export$f26331a5953372af = (0, $d2LG0.default)`mutation WatchDialogWatchContentMutation($id:ID!){watchContent(watchContentInput:{contentId:$id currentUser:true}){content{id currentUserIsWatching}}}`;

});


//# sourceMappingURL=WatchDialog.4acb48cb.js.map
